import api, { appScope } from "@/lib/api";

const toBytes = (value) => {
  const padded = value + "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = padded.replace(/-/g, "+").replace(/_/g, "/");
  return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
};

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

/** Turn on lock-screen notifications for the app the person is currently using. */
export async function enablePush(scope = appScope()) {
  if (!pushSupported()) {
    throw new Error("On iPhone, add this app to your home screen first, open it from there, then turn notifications on.");
  }
  const registration = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
  await navigator.serviceWorker.ready;
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notifications are blocked for this app in your device settings.");

  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    const { data } = await api.get("/push/config");
    if (!data.enabled) throw new Error("Notifications are not configured on this server yet.");
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: toBytes(data.public_key),
    });
  }
  await api.post("/push/subscriptions", { scope, subscription: subscription.toJSON() });
  return true;
}

export async function disablePush() {
  try {
    const registration = await navigator.serviceWorker.getRegistration("/");
    const subscription = await registration?.pushManager.getSubscription();
    if (subscription) await subscription.unsubscribe();
  } catch (e) {
    console.warn("could not unsubscribe locally; removing the server record anyway", e);
  }
  await api.delete("/push/subscriptions");
  return false;
}
